import { render, staticRenderFns } from "./hospital-transfer.vue?vue&type=template&id=0f215bfc&"
import script from "./hospital-transfer.vue?vue&type=script&lang=ts&"
export * from "./hospital-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./hospital-transfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports